import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// i18n
import { Translate } from 'react-redux-i18n';

// Spectrum
import RegionIcon from '@react/react-spectrum/Icon/GlobeOutline';
import ChevronDown from '@react/react-spectrum/Icon/ChevronDown';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import Popover from '@react/react-spectrum/Popover';
import { List, ListItem } from '@react/react-spectrum/List';

// Actions
import { setLocaleWithFallback } from '../../actions';

// Language Config
import { friendlyLanguageName } from '../../i18n/config';

// Styles
import '../css/LanguageSelector.scss';

class LanguageSelector extends Component {
  componentDidUpdate() {
    // Update footer component to re-render URLs
    const { updateParent } = this.props;
    updateParent();
  }

    renderFriendlyLocale = () => {
      const { locale } = this.props;
      return friendlyLanguageName[locale];
    }

    renderLanguageOptions = () => {
      const { locale, setLocaleAction } = this.props;

      return Object.keys(friendlyLanguageName).map(
        (key) => (
          <ListItem
            role="option"
            selected={key === locale}
            value={key}
            key={key}
            onSelect={() => setLocaleAction(key)}
          >
            {friendlyLanguageName[key]}
          </ListItem>
        ),
      );
    }

    render() {
      const { disabled } = this.props;
      return (
        <div className="cmp-languageselector">
          <OverlayTrigger
            crossOffset={0}
            defaultShow={false}
            delayHide={100}
            disabled={disabled}
            flip
            offset={0}
            placement="top"
            trigger="click"
            variant="default"
          >
            <div className="language-popover-trigger">
              <RegionIcon className="regionIcon" />
              <Translate value="global.footer.region" />
              {' '}
              <span>{this.renderFriendlyLocale()}</span>
              <ChevronDown className="chevronIcon" />
            </div>
            <Popover
              open
              role="dialog"
              title={<Translate value="global.footer.choose_region" />}
              trapFocus
              variant="default"
            >
              <List
                role="listbox"
                style={{
                  maxHeight: '250px',
                }}
                className="languageList"
              >
                {this.renderLanguageOptions()}
              </List>
            </Popover>
          </OverlayTrigger>
        </div>
      );
    }
}

LanguageSelector.propTypes = {
  locale: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  setLocaleAction: PropTypes.func.isRequired,
  updateParent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  disabled: state.common.disableLanguageSelector
});

const mapDispatchToProps = {
  setLocaleAction: setLocaleWithFallback,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
